module.exports = __webpack_public_path__ + "static/media/featuresImgar.5529d618.png";